const boatRentals: BoatRental[] = [
  {
    id: 'cabo-san-lucas-mexico',
    pageTitle: 'Cabo San Lucas Boat Charters & Rentals',
    h1: 'Rent a Boat in Cabo San Lucas, Mexico',
    queryParams: {
      latitudeSw: 22.8719539215,
      longitudeSw: -110.0216080368,
      latitudeNe: 22.9954640624,
      longitudeNe: -109.7564143058,
      near: 'Cabo San Lucas, BCS, Mexico',
    },
    metaDescription:
      "Charter a boat of your choice for the perfect on-the-water experience. Boatsetter's dedicated white glove concierge team is here to help!",
    short: 'Cabo San Lucas',
  },
  {
    id: 'san-jose-del-cabo-mexico',
    pageTitle: 'San Jose del Cabo Boat Charters & Rentals',
    h1: 'Rent a Boat in San Jose del Cabo, Mexico',
    queryParams: {
      latitudeSw: 22.8302243449,
      longitudeSw: -109.9145230594,
      latitudeNe: 23.3548348205,
      longitudeNe: -109.4719728599,
      near: 'San José del Cabo, BCS, Mexico',
    },
    metaDescription:
      "Charter a boat of your choice for the perfect on-the-water experience. Boatsetter's dedicated white glove concierge team is here to help!",
    short: 'San Jose del Cabo',
  },
  {
    id: 'puerto-vallarta-mexico',
    pageTitle: 'Puerto Vallarta Boat Rentals & Charters',
    h1: 'Rent a Boat in Puerto Vallarta, Mexico',
    queryParams: {
      latitudeSw: 20.5816065325,
      longitudeSw: -105.2708690175,
      latitudeNe: 20.7001141741,
      longitudeNe: -105.1777452278,
      near: 'Puerto Vallarta, Jalisco, Mexico',
    },
    metaDescription:
      "Charter a boat of your choice for the perfect on-the-water experience. Boatsetter's dedicated white glove concierge team is here to help!",
    short: 'Puerto Vallarta',
  },
  {
    id: 'cancun-mexico',
    pageTitle: 'Cancun Boat Rentals & Charters',
    h1: 'Rent a Boat in Cancun, Mexico',
    queryParams: {
      latitudeSw: 21.0297632383,
      longitudeSw: -86.9722675545,
      latitudeNe: 21.2130332751,
      longitudeNe: -86.7405401406,
      near: 'Cancún, Quintana Roo, Mexico',
    },
    metaDescription:
      "Charter a boat of your choice for the perfect on-the-water experience. Boatsetter's dedicated white glove concierge team is here to help!",
    short: 'Cancun',
  },
  {
    id: 'playa-del-carmen-mexico',
    pageTitle: 'Playa del Carmen Boat Rentals & Charters',
    h1: 'Rent a Boat in Playa del Carmen, Mexico',
    queryParams: {
      latitudeSw: 20.4441823834,
      longitudeSw: -87.2944174763,
      latitudeNe: 20.8689927982,
      longitudeNe: -86.8657249708,
      near: 'Playa del Carmen, Quintana Roo, Mexico',
    },
    metaDescription:
      "Charter a boat of your choice for the perfect on-the-water experience. Boatsetter's dedicated white glove concierge team is here to help!",
    short: 'Playa del Carmen',
  },
  {
    id: 'turks-and-caicos',
    pageTitle: 'Turks and Caicos Boat Rentals & Charters',
    h1: 'Rent a Boat in Turks and Caicos',
    queryParams: {
      latitudeSw: 21.1459922083,
      longitudeSw: -72.5207000167,
      latitudeNe: 22.0016284663,
      longitudeNe: -71.059499934,
      near: 'Turks and Caicos Islands',
    },
    metaDescription:
      "Charter a boat of your choice for the perfect on-the-water experience. Boatsetter's dedicated white glove concierge team is here to help!",
    short: 'Turks and Caicos',
  },
  {
    id: 'saint-martin',
    pageTitle: 'Saint Martin Boat Rentals & Charters',
    h1: 'Rent a Boat in Saint Martin',
    queryParams: {
      latitudeSw: 17.8897312487,
      longitudeSw: -63.3190000657,
      latitudeNe: 18.2916000794,
      longitudeNe: -62.8053000866,
      near: 'St Martin',
    },
    metaDescription:
      "Charter a boat of your choice for the perfect on-the-water experience. Boatsetter's dedicated white glove concierge team is here to help!",
    short: 'Saint Martin',
  },
  {
    id: 'anguilla',
    pageTitle: 'Anguilla Boat Charters & Rentals',
    h1: 'Rent a Boat in Anguilla',
    queryParams: {
      latitudeSw: 17.9125043383,
      longitudeSw: -63.7143000049,
      latitudeNe: 18.8672325896,
      longitudeNe: -62.6860000122,
      near: 'Anguilla',
    },
    metaDescription:
      "Charter a boat of your choice for the perfect on-the-water experience. Boatsetter's dedicated white glove concierge team is here to help!",
    short: 'Anguilla',
  },
  {
    id: 'saint-barthelemy',
    pageTitle: 'St Barths Boat Charters & Rentals',
    h1: 'Rent a Boat in St Barths',
    queryParams: {
      latitudeSw: 17.6442647017,
      longitudeSw: -63.1082267526,
      latitudeNe: 18.1631044918,
      longitudeNe: -62.5550913128,
      near: 'Saint-Barthélemy Island, 97133, St Barthélemy',
    },
    metaDescription:
      "Charter a boat of your choice for the perfect on-the-water experience. Boatsetter's dedicated white glove concierge team is here to help!",
    short: 'St. Barths',
  },
  {
    id: 'nassau-the-bahamas',
    pageTitle: 'Nassau Boat Rentals & Charters',
    h1: 'Rent a Boat in Nassau, The Bahamas',
    queryParams: {
      latitudeSw: 24.97890031905646,
      longitudeSw: -77.5559234156322,
      latitudeNe: 25.08622076436888,
      longitudeNe: -77.25826265109018,
      near: 'Nassau, The Bahamas',
    },
    metaDescription:
      "Charter a boat of your choice for the perfect on-the-water experience. Boatsetter's dedicated white glove concierge team is here to help!",
    short: 'The Bahamas',
  },
  {
    id: 'grand-cayman-cayman-islands',
    pageTitle: 'Grand Cayman Boat Rentals & Charters',
    h1: 'Rent a Boat in Grand Cayman, Cayman Islands',
    queryParams: {
      latitudeSw: 19.26293706034017,
      longitudeSw: -81.42020294701692,
      latitudeNe: 19.39681718826497,
      longitudeNe: -81.08465200721439,
      near: 'Grand Cayman, Cayman Islands',
    },
    metaDescription:
      "Charter a boat of your choice for the perfect on-the-water experience. Boatsetter's dedicated white glove concierge team is here to help!",
    short: 'Cayman Islands',
  },
  {
    id: 'la-romana-dominican-republic',
    pageTitle: 'La Romana Boat Charters & Rentals',
    h1: 'Rent a Boat in La Romana, Dominican Republic',
    queryParams: {
      latitudeSw: 18.39614875825055,
      longitudeSw: -69.05997272311772,
      latitudeNe: 18.46927037235193,
      longitudeNe: -68.88506806654838,
      near: 'La Romana, Dominican Republic',
    },
    metaDescription:
      "Charter a boat of your choice for the perfect on-the-water experience. Boatsetter's dedicated white glove concierge team is here to help!",
    short: 'La Romana',
  },
  {
    id: 'punta-cana-dominican-republic',
    pageTitle: 'Punta Cana Boat Rentals & Charters',
    h1: 'Rent a Boat in Punta Cana, Dominican Republic',
    queryParams: {
      latitudeSw: 18.4414207285345,
      longitudeSw: -68.62197856713118,
      latitudeNe: 18.84083609199668,
      longitudeNe: -68.3228899923726,
      near: 'Punta Cana, Dominican Republic',
    },
    metaDescription:
      "Charter a boat of your choice for the perfect on-the-water experience. Boatsetter's dedicated white glove concierge team is here to help!",
    short: 'Punta Cana',
  },
  {
    id: 'fajardo-puerto-rico',
    pageTitle: 'Fajardo Boat Rentals & Charters',
    h1: 'Rent a boat in Fajardo, Puerto Rico',
    queryParams: {
      latitudeSw: 18.30619595325557,
      longitudeSw: -65.68592006961246,
      latitudeNe: 18.36030199047645,
      longitudeNe: -65.62460399102928,
      near: 'Fajardo, Puerto Rico',
    },
    metaDescription:
      "Charter a boat of your choice for the perfect on-the-water experience. Boatsetter's dedicated white glove concierge team is here to help!",
    short: 'Puerto Rico',
  },
  {
    id: 'puerto-aventura-mexico',
    pageTitle: 'Puerto Aventuras Boat Rentals & Charters',
    h1: 'Rent a boat in Puerto Aventuras, Mexico',
    queryParams: {
      latitudeSw: 20.49226391961519,
      longitudeSw: -87.23982810979655,
      latitudeNe: 20.52235672273934,
      longitudeNe: -87.21540647549277,
      near: '77733 Puerto Aventuras, Quintana Roo, Mexico',
    },
    metaDescription:
      "Charter a boat of your choice for the perfect on-the-water experience. Boatsetter's dedicated white glove concierge team is here to help!",
    short: 'Puerto Aventuras',
  },
  {
    id: 'saint-lucia',
    pageTitle: 'Saint Lucia Boat Rentals & Charters',
    h1: 'Rent a boat in Saint Lucia',
    queryParams: {
      latitudeSw: 13.4707779414,
      longitudeSw: -61.3160091099,
      latitudeNe: 14.3549276688,
      longitudeNe: -60.6257946105,
      near: 'St Lucia',
    },
    metaDescription:
      "Charter a boat of your choice for the perfect on-the-water experience. Boatsetter's dedicated white glove concierge team is here to help!",
    short: 'Saint Lucia',
  },
  {
    id: 'antigua-and-barbuda',
    pageTitle: 'Antigua and Barbuda Boat Rentals & Charters',
    h1: 'Rent a boat in Antigua and Barbuda',
    queryParams: {
      latitudeSw: 16.9308125654,
      longitudeSw: -62.3944822117,
      latitudeNe: 17.8866279351,
      longitudeNe: -61.4603553006,
      near: 'Antigua and Barbuda',
    },
    metaDescription:
      "Charter a boat of your choice for the perfect on-the-water experience. Boatsetter's dedicated white glove concierge team is here to help!",
    short: 'Antigua and Barbuda',
  },
  {
    id: 'barbados',
    pageTitle: 'Barbados Boat Rentals & Charters',
    h1: 'Rent a boat in Barbados',
    queryParams: {
      latitudeSw: 13.0004970247,
      longitudeSw: -59.6742386826,
      latitudeNe: 13.3275393188,
      longitudeNe: -59.4202933314,
      near: 'Barbados',
    },
    metaDescription:
      "Charter a boat of your choice for the perfect on-the-water experience. Boatsetter's dedicated white glove concierge team is here to help!",
    short: 'Barbados',
  },
  {
    id: 'british-virgin-islands',
    pageTitle: 'British Virgin Islands Boat Rentals & Charters',
    h1: 'Rent a boat in British Virgin Islands',
    queryParams: {
      latitudeSw: 17.9766868,
      longitudeSw: -65.1905265,
      latitudeNe: 19.1256392,
      longitudeNe: -63.8867465,
      near: 'British Virgin Islands',
    },
    metaDescription:
      "Charter a boat of your choice for the perfect on-the-water experience. Boatsetter's dedicated white glove concierge team is here to help!",
    short: 'British Virgin Islands',
  },
  {
    id: 'mykonos-greece',
    pageTitle: 'Mykonos Boat Rentals & Charters',
    h1: 'Rent a boat in Mykonos, Greece',
    queryParams: {
      latitudeSw: 37.3526939137,
      longitudeSw: 25.2465303653,
      latitudeNe: 37.5364286864,
      longitudeNe: 25.4246367473,
      near: 'Mykonos 846 00, Greece',
    },
    metaDescription:
      "Charter a boat of your choice for the perfect on-the-water experience. Boatsetter's dedicated white glove concierge team is here to help!",
    short: 'Mykonos',
  },
  {
    id: 'amalfi-italy',
    pageTitle: 'Amalfi Boat Rentals & Charters',
    h1: 'Rent a boat in Amalfi, Italy',
    short: 'Amalfi',
    queryParams: {
      latitudeSw: 40.4622664863,
      longitudeSw: 14.4194349829,
      latitudeNe: 40.7997113065,
      longitudeNe: 14.763900515,
      near: '84011 Amalfi, SA, Italy',
    },
    metaDescription:
      "Charter a boat of your choice for the perfect on-the-water experience. Boatsetter's dedicated white glove concierge team is here to help!",
  },
];

export interface BoatRental {
  id: string;
  pageTitle: string;
  h1: string;
  short: string;
  queryParams: {
    latitudeSw: number;
    longitudeSw: number;
    latitudeNe: number;
    longitudeNe: number;
    near: string;
  };
  metaDescription: string;
}

export interface BoatRentalTransformed {
  lat: number;
  lng: number;
  sw_lat: number;
  sw_lng: number;
  ne_lat: number;
  ne_lng: number;
  lat_lng_sw: string;
  lat_lng_ne: string;
  near: string;
  source: string;
  action: string;
}

const transformBoatRental = (input: BoatRental): BoatRentalTransformed => {
  return {
    lat: (input.queryParams.latitudeSw + input.queryParams.latitudeNe) / 2,
    lng: (input.queryParams.longitudeSw + input.queryParams.longitudeNe) / 2,
    sw_lat: input.queryParams.latitudeSw,
    sw_lng: input.queryParams.longitudeSw,
    ne_lat: input.queryParams.latitudeNe,
    ne_lng: input.queryParams.longitudeNe,
    lat_lng_sw: `${input.queryParams.latitudeSw},${input.queryParams.longitudeSw}`,
    lat_lng_ne: `${input.queryParams.latitudeNe},${input.queryParams.longitudeNe}`,
    near: input.queryParams.near,
    source: 'search',
    action: 'search',
  };
};

export { boatRentals, transformBoatRental };
